export const SEARCH_BAR_TEST_ID = 'SearchBar';
export const SEARCH_BAR_INPUT_TEST_ID = 'SearchBarInput';
export const INLINE_VALIDATION_TEST_ID = 'InlineValidation';
export const SEARCH_BUTTON_TEST_ID = 'SearchButton';
